import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
var translationEN = require("./locales/en/translationEN.json");
var translationDE = require("./locales/de/translationDE.json");
var translationFR = require("./locales/fr/translationFR.json");
var collaborationEN = require("./locales/en/collaborationEN.json");
var collaborationDE = require("./locales/de/collaborationDE.json");
var collaborationFR = require("./locales/fr/collaborationFR.json");

// the translations
const resources = {
  en: {
    translation: translationEN,
    collaboration: collaborationEN,
  },
  de: {
    translation: translationDE,
    collaboration: collaborationDE,
  },
  fr: {
    translation: translationFR,
    collaboration: collaborationFR,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    keySeparator: false, // we do not use keys in form messages.welcome
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
